import { useCallback } from 'react'
import { CIMSBasicFieldProps } from '../../../CIMSBasicFields/types'
import { ProjectCustomField } from '../../ProjectCustomFieldsContext/types'
import { CustomField } from 'schema'
import { useProjectCustomFieldsContext } from '../../ProjectCustomFieldsContext'

export function useFoundCallback() {
  const { customFieldIdToProjectCustomField, classType } =
    useProjectCustomFieldsContext()
  const callback = useCallback<UseFoundCallbackFn>(
    ({ customField, customFieldId, children, hidden }) => {
      const found = customFieldIdToProjectCustomField?.get(customFieldId)
      const { prominent, alwaysVisible } =
        found?.customFieldToClassTypes?.find(
          (cf2ct) => cf2ct.classTypeId === classType?.id
        ) ?? {}
      return {
        hidden: hidden || (found?.deleted ? !alwaysVisible : prominent),
        label: found?.name ?? customField.name,
        help: found?.description ?? customField.description,
        children:
          typeof children === 'function' && found ? children(found) : children,
      }
    },
    [classType, customFieldIdToProjectCustomField]
  )

  return callback
}

type UseFoundCallbackFn = (
  options: UseFoundCallbackOptions
) => CIMSBasicFieldProps

interface UseFoundCallbackOptions extends Pick<CIMSBasicFieldProps, 'hidden'> {
  children: React.ReactNode | ((found: ProjectCustomField) => React.ReactNode)
  customFieldId: string
  customField: Pick<CustomField, 'name' | 'description'>
}
